/* eslint-disable no-use-before-define */
import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import LongText from '../Elements/LongText';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import userHelper from '../Helpers/userHelper';

export default class TpWaveItem {
  constructor(item) {
    if (item === undefined) {
      this.TpWaveId = '';
      this.ThirdPartyWaveName = '';
      this.ThirdPartyWaveId = '';
      this.ThirdPartyClientId = '';
      this.ThirdPartySource = '';
      this.Selected = false;

      return;
    }
    this.TpWaveId = item.tpWaveId;
    this.ThirdPartyWaveName = item.thirdPartyWaveName;
    this.ThirdPartyWaveId = item.thirdPartyWaveId;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.ThirdPartySource = item.thirdPartySource;
    this.Selected = item.selected;
  }

  static NameOfTheIdField() {
    return 'TpWaveId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc', 'ModifiedOnUtc'];
  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    return `${item.ThirdPartyWaveName} (${item.ThirdPartyWaveId})`;
  }

  static clickOnSelect(item) {
    alert('Click');
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div>
        <input
          type='checkbox'
          checked={item.Selected}
          onClick={(e) => {
            TpWaveItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static FieldsToShowInDataTable() {
    // prettier-ignore
    return [
      { label: 'Selected', orderById: '', data: TpWaveItem.getSelectedCellContent, minWidth: 2 },
      {
        label: 'Id',
        orderById: 'TpWaveId',
        data: 'TpWaveId',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Third-Party Wave ID',
        orderById: 'ThirdPartyWaveId',
        data: 'ThirdPartyWaveId',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Name',
        orderById: 'ThirdPartyWaveName',
        data: (item) => (
          <LongText
            text={item.ThirdPartyWaveName}
            maxLength={50}
          />
        ),
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource', type: FieldTypesEnum.PureDataField },
      {
        label: " ",
        orderById: "",
        data: TpWaveItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  // prettier-ignore
  static FieldsToShowInListTable = [
    {
      tabName: "General", tabLabel: "General", icon: "fa-solid fa-users",
      data: [
        { name: "TpWaveId", label: "ID", className: "text-left" },
        { name: 'ThirdPartyWaveId', label: 'Third-Party Wave ID', className: 'text-left' },
        { name: "ThirdPartyWaveName", label: "Name", className: "text-left" },
        { name: "ThirdPartySource", label: "Source", className: "text-left" },
      ],
    },
  ];

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Remove Association',
            onClick: () => TpWaveItem.removeAssociationFunction(item.CfId, item),
            roleKey: 'project_edit',
            disabled: !userHelper.isAdmin(),
          },
        ]}
      />
    );
  }

  static removeAssociationFunction = (id, item, itemList) => {
    alert('Empty function');
  };
}
